import {
  onRequestFulFilled,
  onRequestRejected,
  onResponseFulFilled,
  onResponseRejected,
} from "@/application/api/axiosInterceptor";
import axios, { AxiosRequestConfig } from "axios";

export type CreateResponse = { data: { id: string } | Record<string, unknown> };

const config: AxiosRequestConfig = {
  headers: {
    Accept: "application/json",
  },
};

const instance = axios.create(config);

instance.interceptors.request.use(onRequestFulFilled, onRequestRejected);
instance.interceptors.response.use(onResponseFulFilled, onResponseRejected);

export const { get } = instance;
export const { post } = instance;
export const { put } = instance;
export const destroy = instance.delete;
export const { patch } = instance;
